import { call, put } from 'redux-saga/effects';
import { ActionType } from 'deox';

import { checkAccessToken } from '@/utils/handle-authentication';
import { handleAPIError } from '@/utils/handle-api-error';
import { projectExportManual, TProjectExportManualResponse } from '@/services/api/project-export';
import { projectExportManualAction } from '@/redux/actions/project-export';

// FUNCTION
export function* projectExportManualSaga(action: ActionType<typeof projectExportManualAction.request>): Generator {
  const { language, successCallback, failedCallback } = action.payload;
  try {
    yield call(checkAccessToken);
    const response = yield call(projectExportManual, language);
    const projectExportManualResponse = response as TProjectExportManualResponse;
    yield put(projectExportManualAction.success(projectExportManualResponse));
    successCallback?.(projectExportManualResponse);
  } catch (err) {
    handleAPIError(err, 'Error.getProjectPDFFileError');
    yield put(projectExportManualAction.failure(err));
    failedCallback?.(err);
  }
}
